import type { ClientCancellationLineQueueQuery } from '../../types/clientCancellationLines';

export const CLIENT_CANCELLATION_STALE_MS = 60_000;

export const clientCancellationQueryKeys = {
  suspensionBlock: () => ['client-cancellation-lines', 'suspension-block'] as const,
  byContract: (contractId: string) => ['client-cancellation-lines', 'contract', contractId] as const,
  queue: (query: ClientCancellationLineQueueQuery) =>
    ['client-cancellation-lines', 'queue', query.referenceDate, !!query.includeOverdue] as const,
};
